import { createSelector } from 'reselect';

const slice = ({ cityBikes }) => cityBikes;

export const cityBikesDataSelector = createSelector(
  slice,
  ({ items }) => items
);

export const cityBikesErrorSelector = createSelector(
  slice,
  ({ error }) => error
);

export const cityBikesFetchingSelector = createSelector(
  slice,
  ({ isFetching }) => isFetching
);



// WEBPACK FOOTER //
// ./src/selectors/cityBikes.js